import { API_STATES } from "@/helpers";

const state = {
  requestTypesGetState   : API_STATES.NOT_REQUESTED,
  requestTypeDeleteState : API_STATES.NOT_REQUESTED,
  requestTypesGetError   : null,
  requestTypeDeleteError : null,
  requestTypes           : [],
  requestTypeCreateState : API_STATES.NOT_REQUESTED,
  requestTypeCreateError : null,
  requestTypeUpdateState : API_STATES.NOT_REQUESTED,
  requestTypeUpdateError : null,
  requestType            : {}
};

export default state;
